import React from 'react';
import PropTypes from 'prop-types';

export default function SuccessActivatedText({ isFree }) {
  if (isFree) {
    return (
      <>
        <p className="mt-3">
          We&apos;re thrilled to have you with us.
        </p>
        <p className="mt-3">
          Invite your team to unlock their free Talent Assessment.
          Start the path towards enhanced leadership development and heightened team
          engagement now. Thank you for taking this important step with LeggUP.
          We&apos;re here to support you every step of the way.
        </p>
      </>
    );
  }

  return (

    <p className="mt-3">
      Once your policy is activated, we require some additional information
      from you to be able to invite members.
      This includes your billing details. You can provide this information
      securely by accessing the billing section of the platform.
      Once your billing info has been submitted, your policy will be
      activated and you&apos;ll be ready to support your team.
      Thank you for taking this important step towards ensuring
      your team&apos;s success.
    </p>
  );
}

SuccessActivatedText.propTypes = {
  isFree: PropTypes.bool.isRequired,
};
